// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-nbia-default, .btn-nbia-i-cart, .btn-nbia-i-default, .btn-nbia-li-default {
  border: solid #cccccc 1px;
  background-color: #ffffff;
  height: calc(32px + 2px);
  outline: none;
  user-select: none;
  box-shadow: none !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.btn-nbia-default:hover, .btn-nbia-i-cart:hover, .btn-nbia-i-default:hover, .btn-nbia-li-default:hover {
  border: solid #adadad 1px;
  background-color: #e6e6e6;
}

.btn-nbia-default:disabled, .btn-nbia-i-cart:disabled, .btn-nbia-i-default:disabled, .btn-nbia-li-default:disabled {
  border: solid #d3d2d2 1px;
  background-color: #f4f3f3;
}

.btn-nbia-li-default {
  /* T R B L */
  padding: 0px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-height: 45px;
}

.btn-nbia-i-default {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn:disabled {
  cursor: not-allowed;
}

.btn-nbia-i-cart {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn-nbia-i-cart:hover {
  background-color: lightcoral;
}

.card-nbia-header, .card-nbia-header-default, .card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  padding-bottom: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  height: 58px;
}

.card-nbia-header-danger {
  background-color: #f2dede;
  color: #a94442;
  border-bottom: solid #ebccd1 1px;
}

.card-nbia-danger {
  border-color: #ebccd1;
  border-radius: 3px;
}

.card-nbia-header-default {
  height: 43px;
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-header-with-icon-default {
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-default {
  border-color: #bce8f1;
  border-radius: 3px;
}

/* Space between menu bar and top of content */
.query-panel-heading {
  color: #bb0e3d;
}

.query-panel-heading {
  background-color: #fff;
  font-size: 12pt;
}

.dark-row {
  background-color: #f4f4f4;
}

.cart-child-selected {
  background-color: #ff7 !important;
}

.redCart {
  background-color: lightcoral;
}

.greenCart, .cart-selected {
  background-color: aquamarine !important;
}

/* Cart button on Cart screen */
.cart-button {
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
}

/* Trying to clean this up for Chrome */
.no-outline, .nbia-button {
  outline: none;
}

.child-data-display {
  background-color: #fff;
  border: solid 1px #e7e7e7;
  /*  Show some parent background */
  margin: 8px 8px 16px 8px;
  /* Child display */
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 24px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.child-data-display-parent-background {
  background-color: #edf8fb;
}

/*  TODO  explain  */
.alert-box-div {
  z-index: 21;
  position: absolute;
  /* Set the vertical location of all the Alert/Message boxes.  */
  margin-top: 100px;
}

.alert-box-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.alert-box-button {
  float: right;
  margin-left: 4px;
}

.alert-box-icon {
  font-size: x-large;
}

.hide-item {
  display: none;
}

.nbia-loading-label {
  color: #fff;
  /*background-color: #00f8f8;*/
  font-size: 12pt;
}

/*Odd and even, but skipping the top row (Heading)*/
tr:nth-child(even) {
  background: #fff;
}

tr:nth-child(2n+3) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(even) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(2n+3) {
  background: #fff;
}

.nbia-drop-down {
  min-width: 60px;
}

.nbia-drop-down > li > a:hover {
  /*background: #baffff;*/
  background: #dde8eb;
}

.busy-pointer {
  cursor: wait;
}

.disabled-busy-check {
  color: #999;
  cursor: wait;
}

.disabled-check {
  color: #aaa;
  cursor: default;
}

.cart-td {
  width: 94px;
  border-left: none;
  margin-right: 0px;
  margin-left: 0px;
  padding-right: 0px;
  padding-left: 0px;
}

/* ********* Buttons ******** */
.nbia-button {
  color: #fff;
  background-color: #0b7983;
  cursor: pointer;
  /*
  font-size: 10pt;
  */
}

.nbia-button:hover {
  background-color: #277599;
}

.nbia-button:active {
  background-color: #1e5975;
}

.nbia-button-disabled:active {
  cursor: not-allowed;
  background-color: #70a4bd;
  color: #f5fafa;
}

.nbia-button-disabled:hover {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.nbia-button-disabled {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.clicker {
  cursor: pointer;
}

.search-results-cart-count {
  background-color: #5b5151;
  color: #fff;
  border-radius: 3px;
  padding: 3px 6px 3px 6px;
  /*margin-left: 2px;*/
  margin-left: -5px;
  margin-bottom: 2px;
  font-size: 8pt;
}

.thead-td {
  background-color: #dedddd;
  border: solid 1px #dedddd;
  height: 50px;
  font-weight: bold;
}

/* For first column headers that would otherwise but up against the left edge and look crowded  */
.thead-td1 {
  padding-left: 3px;
}

.footer-colors {
  color: #686868;
}

.number-spinner {
  border: solid 1px #686868;
  border-radius: 3px;
  position: relative;
  top: 0px;
  padding: 0 4px 0 4px;
  margin: 10px 2px 0 4px;
  width: 60px;
  height: 28px;
}

.rows-per-page-spinner {
  color: #686868;
  margin-bottom: 12px;
}

.popup-heading-text {
  font-size: 12pt;
  font-weight: bold;
}

.close-x {
  font-weight: bold;
  font-family: "Arial Black", Gadget, sans-serif;
  color: #800;
  float: right;
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.application-menu-icon {
  width: 14px;
  height: 14px;
}

.cart-button-icon {
  width: 14px;
  height: 14px;
}

.cart-delete-button-icon {
  height: 20px;
  padding: 0 3px 1px 0;
}

.chevron-right-icon {
  height: 14px;
}

.chevron-down-icon {
  width: 14px;
}

.sort-triangle {
  height: 14px;
}

label {
  font: 15px arial, sans-serif;
}

.query-input-main-panel-div {
  background-color: #fff;
  width: 100%;
}

/*For the individual query entry panels */
.query-panel-heading {
  padding: 7px 0 0 0;
  margin-left: 15pt;
  margin-bottom: 7pt;
  font-size: 12pt;
}

.query-panel-checkboxes {
  color: #3a3a3a;
  margin-left: 15pt;
}

.third-party-query-panel {
  padding-bottom: 8px;
}

.clinical-time-points-query-panel {
  padding-bottom: 8px;
}

.subjects-sex-search-panel {
  padding-bottom: 8px;
}

.subjects-sex-query-panel {
  padding-bottom: 8px;
}

.phantom-query-panel {
  padding-bottom: 8px;
}

.query-panel {
  background-color: #fff;
  border-bottom: solid 1px #cfcfcf;
  border-left: solid 1px #cfcfcf;
  border-right: solid 1px #cfcfcf;
}

.moreOrLess {
  margin-left: 266px;
  /*  It's a link, but we want no underline */
  text-decoration: none;
  cursor: pointer;
}

.hide-div {
  display: none;
}

.count-box {
  color: #fff;
  background-color: #5b5151;
  border-radius: 3px;
  padding: 1px 5px 1px 5px;
  margin-right: 15px;
  float: right;
  font-size: 8pt;
}

.check-box {
  margin-right: 4px;
}

.criteria-entry-text {
  margin-top: 4px;
  margin-bottom: 3px;
}

.count-box_zero {
  color: #fff;
  background-color: #a39999;
  border-radius: 3px;
  padding: 1px 5px 1px 5px;
  margin-right: 15px;
  float: right;
  font-size: 8pt;
}

.search-glass {
  position: absolute;
  left: 340px;
}

.red-clear {
  position: absolute;
  left: 343px;
}

.search-glass-with-clear {
  position: absolute;
  left: 321px;
}

.search-box {
  border: solid 1px #cfcfcf;
  border-radius: 4px;
  padding: 0 0 0 12px;
  margin-left: 15pt;
  margin-bottom: 10pt;
  height: 34px;
  width: calc(100% - 35px);
}

/* Trying to clean this up for Chrome */
.box-with-focus {
  outline: none;
}

.search-text-area {
  border-style: none;
  height: 30px;
  width: calc(100% - 25px);
}

.search-text-area-x {
  margin: 6px 6px 0px 0px;
  cursor: pointer;
}

.any-or-all {
  color: #3a3a3a;
  margin-left: 5pt;
}

.phantom-radio {
  color: #3a3a3a;
  margin-left: 15pt;
  margin-bottom: 6px;
  cursor: pointer;
}

.phantom-radio-label {
  cursor: pointer;
}

.sex-radio {
  color: #3a3a3a;
  margin-left: 15pt;
  margin-bottom: 6px;
  cursor: pointer;
}

.sex-radio-label {
  cursor: pointer;
}

.thirdParty-radio {
  color: #3a3a3a;
  margin-left: 15pt;
  margin-bottom: 6px;
  cursor: pointer;
}

.thirdParty-radio-label {
  cursor: pointer;
}

.sort-text {
  color: #3a3a3a;
  font-size: 9pt;
}

.phantoms-apply-checkbox {
  margin-left: 25px;
  cursor: default;
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  border: solid #cfcfcf 1px;
}

.sex-apply-checkbox {
  margin-left: 25px;
  cursor: default;
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  border: solid #cfcfcf 1px;
}

.thirdParty-apply-checkbox {
  margin-left: 25px;
  cursor: default;
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  border: solid #cfcfcf 1px;
}

.phantoms-apply-glyph {
  cursor: default;
  color: #00aa00;
  margin-right: 4px;
}

.sex-apply-glyph {
  cursor: default;
  color: #00aa00;
  margin-right: 4px;
}

/*

.phantoms-apply-glyph{
  //margin-left: 5pt;
  cursor: default;
  color: \$close-x-red;
  margin-right: 4px;
}
*/
.phantoms-status {
  font-size: 10pt;
}

.sex-status {
  font-size: 10pt;
}

.thirdParty-status {
  font-size: 10pt;
}

.close-third-party-explanation-x {
  float: right;
  margin-right: 10px;
  height: 16px;
}

.third-party-explanation-text {
  font-size: 12pt;
  margin: 8px;
}

.close-subjects-tab-explanation-x {
  float: right;
  margin-right: 10px;
  height: 16px;
}

.subjects-tab-explanation-text {
  font-size: 12pt;
  margin: 8px;
}

.collection-scroller-div {
  padding-bottom: 12px;
  resize: vertical;
  overflow: auto;
}

.collection-scroller {
  height: 100%;
}

.collection-scroller-content {
  height: 120px;
}

.fixed-width {
  width: 345px;
}`, "",{"version":3,"sources":["webpack://./src/app/btn-nbia.scss","webpack://./src/app/image-search/query-section/query-section-tabs/subjects-search-tab/subjects-search-tab.component.scss","webpack://./src/app/card-nbia.scss","webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAWA;EACI,yBAAA;EACA,yBATuB;EAUvB,wBAAA;EAEA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ACXJ;;ADcA;EACI,yBAAA;EACA,yBAtB6B;ACWjC;;ADcA;EACI,yBAAA;EACA,yBA1BgC;ACepC;;ADeA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;ACbJ;;ADiBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACfJ;;ADkBA;EACI,mBAAA;ACfJ;;ADqBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACnBJ;;ADsBA;EACI,4BAAA;ACnBJ;;ACvCA;EACI,iBAAA;EACA,2BAAA;EACA,4BAAA;AD0CJ;;ACtCA;EAEI,YArBgC;AD6DpC;;ACrCA;EAEI,yBAnBuC;EAoBvC,cAnBiC;EAoBjC,gCAAA;ADuCJ;;ACpCA;EACI,qBA1BmC;EA2BnC,kBAAA;ADuCJ;;ACnCA;EAEI,YAxCsB;EAyCtB,yBArCwC;EAsCxC,cArCkC;EAsClC,qBAxCoC;EAyCpC,gCAAA;ADqCJ;;AClCA;EAEI,yBA7CwC;EA8CxC,cA7CkC;EA8ClC,qBAhDoC;EAiDpC,gCAAA;ADoCJ;;ACjCA;EACI,qBArDoC;EAsDpC,kBAAA;ADoCJ;;AE1E6B,8CAAA;AAsB7B;EACI,cArCgC;AF6FpC;;AErDA;EAEI,sBAAA;EACA,eAAA;AFuDJ;;AE/CA;EACI,yBAhDa;AFkGjB;;AE/CA;EACI,iCAAA;AFkDJ;;AE/CA;EACI,4BAAA;AFkDJ;;AE/CA;EACI,uCAAA;AFkDJ;;AE/CA,+BAAA;AACA;EACI,wBAAA;EACA,mBAAA;AFkDJ;;AE9CA,uCAAA;AACA;EACI,aAAA;AFiDJ;;AE9CA;EACI,sBAAA;EACA,yBAAA;EAEA,iCAAA;EACA,wBAAA;EAEA,kBAAA;EACA,YAAA;EAEA,oEAAA;EACA,gFAAA;EAGA,kBAAA;AF4CJ;;AEzCA;EACI,yBAAA;AF4CJ;;AEzCA,oBAAA;AACA;EACI,WA7EY;EA8EZ,kBAAA;EAEA,+DAAA;EACA,iBApGQ;AF+IZ;;AExCA;EACI,4EAAA;AF2CJ;;AExCA;EACI,YAAA;EACA,gBAAA;AF2CJ;;AExCA;EACI,kBAAA;AF2CJ;;AExCA;EACI,aAAA;AF2CJ;;AExCA;EACI,WAAA;EACA,6BAAA;EACA,eAAA;AF2CJ;;AExCA,mDAAA;AACA;EACI,gBAAA;AF2CJ;;AExCA;EACI,mBAAA;AF2CJ;;AExCA;EACI,mBAAA;AF2CJ;;AExCA;EACI,gBAAA;AF2CJ;;AExCA;EACI,eAAA;AF2CJ;;AExCA;EACI,uBAAA;EACA,mBAAA;AF2CJ;;AExCA;EACI,YAAA;AF2CJ;;AExCA;EACI,WAAA;EACA,YAAA;AF2CJ;;AExCA;EACI,WAAA;EACA,eAAA;AF2CJ;;AExCA;EACI,WAAA;EAGA,iBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AFuCJ;;AEnCA,+BAAA;AACA;EAEI,WAAA;EACA,yBAAA;EACA,eAAA;EACA;;GAAA;AFuCJ;;AElCA;EACI,yBAAA;AFqCJ;;AElCA;EACI,yBAAA;AFqCJ;;AElCA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;AFqCJ;;AElCA;EACI,mBAAA;EACA,yBAAA;AFqCJ;;AElCA;EACI,mBAAA;EACA,yBAAA;AFqCJ;;AEjCA;EACI,eAAA;AFoCJ;;AEjCA;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EAEA,wBAAA;EACA,oBAAA;EACA,iBAAA;EAGA,kBAAA;EAEA,cAAA;AFgCJ;;AE7BA;EACI,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AFgCJ;;AE7BA,iGAAA;AACA;EACI,iBAAA;AFgCJ;;AE7BA;EACI,cAAA;AFgCJ;;AE7BA;EACI,yBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AF+BJ;;AE5BA;EACI,cAAA;EACA,mBAAA;AF+BJ;;AE5BA;EACI,eAAA;EACA,iBAAA;AF+BJ;;AE5BA;EACI,iBAAA;EACA,8CAAA;EACA,WAlRU;EAmRV,YAAA;AF+BJ;;AE3BA;EACI,2BAAA;EACA,yBAAA;EAIA,iBAAA;AF8BJ;;AE1BA;EACI,WAAA;EACA,YAAA;AF6BJ;;AEzBA;EACI,WAAA;EACA,YAAA;AF4BJ;;AEzBA;EAEI,YAAA;EACA,oBAAA;AF2BJ;;AEvBA;EACI,YAAA;AF0BJ;;AEvBA;EACI,WAAA;AF0BJ;;AEvBA;EACI,YAAA;AF0BJ;;AA/VA;EACI,4BAAA;AAkWJ;;AA/VA;EACI,sBAAA;EACA,WAAA;AAkWJ;;AA/VA,yCAAA;AACA;EAEI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAiWJ;;AA9VA;EACI,cAAA;EACA,iBAAA;AAiWJ;;AA9VA;EACI,mBAAA;AAiWJ;;AA9VA;EACI,mBAAA;AAiWJ;;AA9VA;EACI,mBAAA;AAiWJ;;AA9VA;EACI,mBAAA;AAiWJ;;AA9VA;EACI,mBAAA;AAiWJ;;AA9VA;EACI,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;AAiWJ;;AA9VA;EACI,kBAAA;EACA,2CAAA;EACA,qBAAA;EACA,eAAA;AAiWJ;;AA9VA;EACI,aAAA;AAiWJ;;AA9VA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAiWJ;;AA9VA;EACI,iBAAA;AAiWJ;;AA9VA;EACI,eAAA;EACA,kBAAA;AAiWJ;;AA9VA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAiWJ;;AA7VA;EACI,kBAAA;EACA,WAAA;AAgWJ;;AA7VA;EACI,kBAAA;EACA,WAAA;AAgWJ;;AA7VA;EACI,kBAAA;EACA,WAAA;AAgWJ;;AA7VA;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AAgWJ;;AA7VA,uCAAA;AACA;EACI,aAAA;AAgWJ;;AA7VA;EACI,kBAAA;EACA,YAAA;EACA,wBAAA;AAgWJ;;AA7VA;EACI,uBAAA;EACA,eAAA;AAgWJ;;AA7VA;EACI,cAAA;EACA,gBAAA;AAgWJ;;AA7VA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAgWJ;;AA7VA;EACI,eAAA;AAgWJ;;AA7VA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAgWJ;;AA7VA;EACI,eAAA;AAgWJ;;AA7VA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAgWJ;;AA7VA;EACI,eAAA;AAgWJ;;AA7VA;EACI,cAAA;EACA,cAAA;AAgWJ;;AA7VA;EACI,iBAAA;EACA,eAAA;EAEA,YAAA;EACA,oEAAA;EACA,8EAAA;EAIA,kBAAA;EACA,yBAAA;AA4VJ;;AAzVA;EACI,iBAAA;EACA,eAAA;EAEA,YAAA;EACA,oEAAA;EACA,8EAAA;EAIA,kBAAA;EACA,yBAAA;AAwVJ;;AArVA;EACI,iBAAA;EACA,eAAA;EAEA,YAAA;EACA,oEAAA;EACA,8EAAA;EAIA,kBAAA;EACA,yBAAA;AAoVJ;;AAjVA;EAEI,eAAA;EACA,cAAA;EACA,iBAAA;AAmVJ;;AAhVA;EAEI,eAAA;EACA,cAAA;EACA,iBAAA;AAkVJ;;AA/UA;;;;;;;;CAAA;AAUA;EACI,eAAA;AAiVJ;;AA9UA;EACI,eAAA;AAiVJ;;AA9UA;EACI,eAAA;AAiVJ;;AA7UA;EACI,YAAA;EACA,kBAAA;EACA,YAAA;AAgVJ;;AA5UA;EACI,eAAA;EACA,WAAA;AA+UJ;;AA5UA;EACI,YAAA;EACA,kBAAA;EACA,YAAA;AA+UJ;;AA3UA;EACI,eAAA;EACA,WAAA;AA8UJ;;AA1UA;EACI,oBAAA;EACA,gBAAA;EACA,cAAA;AA6UJ;;AA1UA;EACI,YAAA;AA6UJ;;AA1UA;EACI,aApS4B;AAinBhC;;AA1UA;EACI,YAAA;AA6UJ","sourcesContent":["$default-border-color: #cccccc;\n$default-border-hover-color: #adadad;\n$default-border-disabled-color: #d3d2d2;\n\n$default-background-color: #ffffff;\n$default-background-hover-color: #e6e6e6;\n$default-background-disabled-color: #f4f3f3;\n\n$default-height: 32px;\n$default-border-line-width: 1px;\n\n.btn-nbia-default {\n    border: solid $default-border-color $default-border-line-width;\n    background-color: $default-background-color;\n    height: calc(#{$default-height} + #{$default-border-line-width * 2 });\n\n    outline: none;\n    user-select: none;\n    box-shadow: none !important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n.btn-nbia-default:hover {\n    border: solid $default-border-hover-color $default-border-line-width;\n    background-color: $default-background-hover-color;\n}\n\n.btn-nbia-default:disabled {\n    border: solid $default-border-disabled-color $default-border-line-width;\n    background-color: $default-background-disabled-color;\n}\n\n// For buttons with just a larger image/icon Cine mode\n.btn-nbia-li-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 0px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-height: 45px;\n}\n\n// For buttons with just an image/icon\n.btn-nbia-i-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn:disabled{\n    cursor: not-allowed;\n}\n\n\n\n// This for the \"Cart\" page\n.btn-nbia-i-cart {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn-nbia-i-cart:hover {\n    background-color: lightcoral;\n}\n\n","@import '../../../../app.component.scss';\n\n$query-collection-start-height: 120px;\n\nlabel {\n    font: 15px arial, sans-serif;\n}\n\n.query-input-main-panel-div {\n    background-color: #fff;\n    width: 100%;\n}\n\n/*For the individual query entry panels */\n.query-panel-heading {\n    @extend %panel-heading;\n    padding: 7px 0 0 0;\n    margin-left: 15pt;\n    margin-bottom: 7pt;\n    font-size: 12pt;\n}\n\n.query-panel-checkboxes {\n    color: #3a3a3a;\n    margin-left: 15pt;\n}\n\n.third-party-query-panel {\n    padding-bottom: 8px;\n}\n\n.clinical-time-points-query-panel {\n    padding-bottom: 8px;\n}\n\n.subjects-sex-search-panel {\n    padding-bottom: 8px;\n}\n\n.subjects-sex-query-panel {\n    padding-bottom: 8px;\n}\n\n.phantom-query-panel {\n    padding-bottom: 8px;\n}\n\n.query-panel {\n    background-color: #fff;\n    border-bottom: solid 1px #cfcfcf;\n    border-left: solid 1px #cfcfcf;\n    border-right: solid 1px #cfcfcf;\n}\n\n.moreOrLess {\n    margin-left: 266px;\n    /*  It's a link, but we want no underline */\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.hide-div {\n    display: none;\n}\n\n.count-box {\n    color: #fff;\n    background-color: #5b5151;\n    border-radius: 3px;\n    padding: 1px 5px 1px 5px;\n    margin-right: 15px;\n    float: right;\n    font-size: 8pt;\n}\n\n.check-box {\n    margin-right: 4px;\n}\n\n.criteria-entry-text {\n    margin-top: 4px;\n    margin-bottom: 3px;\n}\n\n.count-box_zero {\n    color: #fff;\n    background-color: #a39999;\n    border-radius: 3px;\n    padding: 1px 5px 1px 5px;\n    margin-right: 15px;\n    float: right;\n    font-size: 8pt;\n\n}\n\n.search-glass {\n    position: absolute;\n    left: $left-section-width - 50px;\n}\n\n.red-clear {\n    position: absolute;\n    left: $left-section-width - 47px;\n}\n\n.search-glass-with-clear {\n    position: absolute;\n    left: $left-section-width - 69px;\n}\n\n.search-box {\n    border: solid 1px #cfcfcf;\n    border-radius: 4px;\n    padding: 0 0 0 12px;\n    margin-left: 15pt;\n    margin-bottom: 10pt;\n    height: 34px;\n    width: calc(100% - 35px);\n}\n\n/* Trying to clean this up for Chrome */\n.box-with-focus {\n    outline: none;\n}\n\n.search-text-area {\n    border-style: none;\n    height: 30px;\n    width: calc(100% - 25px);\n}\n\n.search-text-area-x {\n    margin: 6px 6px 0px 0px;\n    cursor: pointer;\n}\n\n.any-or-all {\n    color: #3a3a3a;\n    margin-left: 5pt;\n}\n\n.phantom-radio {\n    color: #3a3a3a;\n    margin-left: 15pt;\n    margin-bottom: 6px;\n    cursor: pointer;\n}\n\n.phantom-radio-label {\n    cursor: pointer;\n}\n\n.sex-radio {\n    color: #3a3a3a;\n    margin-left: 15pt;\n    margin-bottom: 6px;\n    cursor: pointer;\n}\n\n.sex-radio-label {\n    cursor: pointer;\n}\n\n.thirdParty-radio {\n    color: #3a3a3a;\n    margin-left: 15pt;\n    margin-bottom: 6px;\n    cursor: pointer;\n}\n\n.thirdParty-radio-label {\n    cursor: pointer;\n}\n\n.sort-text {\n    color: #3a3a3a;\n    font-size: 9pt;\n}\n\n.phantoms-apply-checkbox {\n    margin-left: 25px;\n    cursor: default;\n\n    padding: 6px;\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1),\n    0 1px 2px 0 rgba(0, 0, 0, 0.075);\n\n\n    border-radius: 5px;\n    border: solid #cfcfcf 1px;\n}\n\n.sex-apply-checkbox {\n    margin-left: 25px;\n    cursor: default;\n\n    padding: 6px;\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1),\n    0 1px 2px 0 rgba(0, 0, 0, 0.075);\n\n\n    border-radius: 5px;\n    border: solid #cfcfcf 1px;\n}\n\n.thirdParty-apply-checkbox {\n    margin-left: 25px;\n    cursor: default;\n\n    padding: 6px;\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1),\n    0 1px 2px 0 rgba(0, 0, 0, 0.075);\n\n\n    border-radius: 5px;\n    border: solid #cfcfcf 1px;\n}\n\n.phantoms-apply-glyph {\n    //margin-left: 5pt;\n    cursor: default;\n    color: #00aa00;\n    margin-right: 4px;\n}\n\n.sex-apply-glyph {\n    //margin-left: 5pt;\n    cursor: default;\n    color: #00aa00;\n    margin-right: 4px;\n}\n\n/*\n\n.phantoms-apply-glyph{\n  //margin-left: 5pt;\n  cursor: default;\n  color: $close-x-red;\n  margin-right: 4px;\n}\n*/\n\n.phantoms-status {\n    font-size: 10pt;\n}\n\n.sex-status {\n    font-size: 10pt;\n}\n\n.thirdParty-status {\n    font-size: 10pt;\n}\n\n\n.close-third-party-explanation-x {\n    float: right;\n    margin-right: 10px;\n    height: 16px;\n}\n\n\n.third-party-explanation-text {\n    font-size: 12pt;\n    margin: 8px;\n}\n\n.close-subjects-tab-explanation-x {\n    float: right;\n    margin-right: 10px;\n    height: 16px;\n}\n\n\n.subjects-tab-explanation-text {\n    font-size: 12pt;\n    margin: 8px;\n}\n\n\n.collection-scroller-div {\n    padding-bottom: 12px;\n    resize: vertical;\n    overflow: auto;\n}\n\n.collection-scroller {\n    height: 100%;\n}\n\n.collection-scroller-content {\n    height: $query-collection-start-height;\n}\n\n.fixed-width {\n    width: $left-section-width - 45px;\n}\n","$card-nbia-header-height: 43px;\n$card-nbia-header-with-icon-height: 58px;\n\n$card-nbia-header-default-border-color: #bce8f1;\n$card-nbia-header-default-background-color: #d9edf7;\n$card-nbia-header-default-text-color: #347391;\n\n$card-nbia-header-danger-border-color: #ebccd1;\n$card-nbia-header-danger-background-color: #f2dede;\n$card-nbia-header-danger-text-color: #a94442;\n\n\n// Abstract\n.card-nbia-header {\n    padding-bottom: 0;\n    border-top-left-radius : 3px;\n    border-top-right-radius : 3px;\n}\n\n// Abstract\n.card-nbia-header-with-icon {\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-with-icon-height;\n}\n\n.card-nbia-header-danger{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-danger-background-color;\n    color: $card-nbia-header-danger-text-color;\n    border-bottom: solid $card-nbia-header-danger-border-color 1px;\n}\n\n.card-nbia-danger{\n    border-color: $card-nbia-header-danger-border-color;\n    border-radius : 3px;\n}\n\n\n.card-nbia-header-default{\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-height;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-header-with-icon-default{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-default{\n    border-color: $card-nbia-header-default-border-color;\n    border-radius : 3px;\n}\n\n","@import './btn-nbia';\n@import './card-nbia';\n\n$left-section-width: 390px;\n\n$query-criteria-heading-text-color: #bb0e3d;\n$disabled-text: #747474;\n$button-down-background: #dedddd;\n\n$dark-row-color: #f4f4f4;\n\n$alert-top: 100px;\n\n$close-x-red: #800;\n\n// $heading-height: 110px;\n$heading-height: 122px;\n\n// FIXME This only is used for the opener/closer icon\n$heading-margin-bottom: 8px; /* Space between menu bar and top of content */\n\n$header-background-color: #013856;\n\n$legacy-feedback-left: 182px;\n\n$top-logo-height: 41px;\n\n$banner-font-size: 20pt;\n$display-query-top: 10px;\n\n$popup-z-index: 21;\n$loading-screen-z-index: 5;\n$tool-tip-z-index: 2;\n$display-query-z-index: 0; // @TODO explain\n$pie-char-description-popup-z-index: 2;\n$missing-criteria-z-index: 3;\n$search-results-column-selector-z-index: 2;\n$intro-z-index: 3;\n$banner-z-index: 6;\n\n\n%panel-heading-text-color {\n    color: $query-criteria-heading-text-color;\n}\n\n%panel-heading {\n    @extend %panel-heading-text-color;\n    background-color: #fff;\n    font-size: 12pt;\n}\n\n%left-section {\n    width: $left-section-width;\n}\n\n\n.dark-row {\n    background-color: $dark-row-color;\n}\n\n.cart-child-selected {\n    background-color: #ff7 !important;\n}\n\n.redCart {\n    background-color: lightcoral;\n}\n\n.greenCart, .cart-selected {\n    background-color: aquamarine !important;\n}\n\n/* Cart button on Cart screen */\n.cart-button {\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n}\n\n\n/* Trying to clean this up for Chrome */\n.no-outline {\n    outline: none;\n}\n\n.child-data-display {\n    background-color: #fff;\n    border: solid 1px #e7e7e7;\n\n    /*  Show some parent background */\n    margin: 8px 8px 16px 8px;\n\n    /* Child display */\n    padding: 6px;\n\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2),\n    0 10px 24px 0 rgba(0, 0, 0, 0.15);\n\n    border-radius: 5px;\n}\n\n.child-data-display-parent-background {\n    background-color: #edf8fb;\n}\n\n/*  TODO  explain  */\n.alert-box-div {\n    z-index: $popup-z-index;\n    position: absolute;\n\n    /* Set the vertical location of all the Alert/Message boxes.  */\n    margin-top: $alert-top;\n}\n\n.alert-box-shadow {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.alert-box-button {\n    float: right;\n    margin-left: 4px;\n}\n\n.alert-box-icon {\n    font-size: x-large;\n}\n\n.hide-item {\n    display: none;\n}\n\n.nbia-loading-label {\n    color: #fff;\n    /*background-color: #00f8f8;*/\n    font-size: 12pt;\n}\n\n/*Odd and even, but skipping the top row (Heading)*/\ntr:nth-child(even) {\n    background: #fff\n}\n\ntr:nth-child(2n+3) {\n    background: #f4f4f4\n}\n\n.nbia-drop-down > li:nth-child(even) {\n    background: #f4f4f4;\n}\n\n.nbia-drop-down > li:nth-child(2n+3) {\n    background: #fff;\n}\n\n.nbia-drop-down {\n    min-width: 60px;\n}\n\n.nbia-drop-down > li > a:hover {\n    /*background: #baffff;*/\n    background: #dde8eb;\n}\n\n.busy-pointer {\n    cursor: wait;\n}\n\n.disabled-busy-check {\n    color: #999;\n    cursor: wait;\n}\n\n.disabled-check {\n    color: #aaa;\n    cursor: default;\n}\n\n.cart-td {\n    width: 94px;\n\n    //    border-color: #ff00dd;\n    border-left: none;\n\n\n    margin-right: 0px;\n    margin-left: 0px;\n    padding-right: 0px;\n    padding-left: 0px;\n\n}\n\n/* ********* Buttons ******** */\n.nbia-button {\n    @extend .no-outline;\n    color: #fff;\n    background-color: #0b7983;\n    cursor: pointer;\n    /*\n    font-size: 10pt;\n    */\n}\n\n.nbia-button:hover {\n    background-color: #277599;\n}\n\n.nbia-button:active {\n    background-color: #1e5975;\n}\n\n.nbia-button-disabled:active {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n    color: #f5fafa;\n}\n\n.nbia-button-disabled:hover {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n.nbia-button-disabled {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n\n.clicker {\n    cursor: pointer;\n}\n\n.search-results-cart-count {\n    background-color: #5b5151;\n    color: #fff;\n    border-radius: 3px;\n\n    padding: 3px 6px 3px 6px;\n    /*margin-left: 2px;*/\n    margin-left: -5px;\n    //  margin-right: -25px;\n\n    margin-bottom: 2px;\n\n    font-size: 8pt;\n}\n\n.thead-td {\n    background-color: #dedddd;\n    border: solid 1px #dedddd;\n    height: 50px;\n    font-weight: bold;\n}\n\n/* For first column headers that would otherwise but up against the left edge and look crowded  */\n.thead-td1 {\n    padding-left: 3px;\n}\n\n.footer-colors {\n    color: #686868;\n}\n\n.number-spinner {\n    border: solid 1px #686868;\n    border-radius: 3px;\n\n    position: relative;\n    top: 0px;\n    padding: 0 4px 0 4px;\n    margin: 10px 2px 0 4px;\n    width: 60px;\n    height: 28px;\n}\n\n.rows-per-page-spinner {\n    color: #686868;\n    margin-bottom: 12px;\n}\n\n.popup-heading-text {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n.close-x {\n    font-weight: bold;\n    font-family: \"Arial Black\", Gadget, sans-serif;\n    color: $close-x-red;\n    float: right;\n}\n\n\n.unselectable {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n\n.application-menu-icon{\n    width: 14px;\n    height: 14px;\n}\n\n\n.cart-button-icon{\n    width: 14px;\n    height: 14px;\n}\n\n.cart-delete-button-icon{\n    // width: 14px;\n    height: 20px;\n    padding: 0 3px 1px 0;\n}\n\n\n.chevron-right-icon{\n    height: 14px;\n}\n\n.chevron-down-icon{\n    width: 14px;\n}\n\n.sort-triangle{\n    height: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
